import script from "./ManageAnnouncements.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageAnnouncements.vue?vue&type=script&setup=true&lang=js"

import "./ManageAnnouncements.vue?vue&type=style&index=0&id=ff08a1c4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff08a1c4"]])

export default __exports__